import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { UserToken } from '../../amorg-common';
import { getMaybeActiveUserOrRefresh, redirectToLogin } from '../../api/serverApiHelpers';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { getUserHomeDestination } from '../../utils/userHomeHelper';
import DashboardPage from '../dashboard/DashboardPage';
import { UserLandingPage } from '../user/overview/UserLandingPage';

export function HomePage(): JSX.Element
{
    const [activeUser, setActiveUser] = React.useState<UserToken | null>(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() =>
    {
        const handle = async () =>
        {
            const result = await getMaybeActiveUserOrRefresh();
            if(result.tokenUser === null)
            {
                redirectToLogin();
                return;
            }

            setActiveUser(result.tokenUser);
            setLoading(false);
        };
        handle();
    }, []);

    if(loading || activeUser === null)
        return <LoadingPageOverlay loading={true} />;

    const destination = getUserHomeDestination(activeUser);

    if(destination === 'articles')
        return <Navigate to="/articles" replace />;

    if(destination === 'user-overview')
        return <UserLandingPage />;

    return <DashboardPage />;
}
